import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, MousePointerClick } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden nexti-gradient">
      {/* Floating decorative shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute top-20 left-10 w-32 h-32 bg-white/10 rounded-full blur-xl animate-float"
          style={{ animationDelay: '0s' }}
        />
        <div
          className="absolute top-40 right-20 w-24 h-24 bg-white/10 rounded-lg blur-xl animate-float"
          style={{ animationDelay: '0.5s' }}
        />
        <div
          className="absolute bottom-32 left-1/4 w-40 h-40 bg-white/10 rounded-full blur-xl animate-float"
          style={{ animationDelay: '1s' }}
        />
        <div
          className="absolute bottom-20 right-1/3 w-28 h-28 bg-white/10 rounded-lg blur-xl animate-float"
          style={{ animationDelay: '2s' }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6 tracking-tight">
          NexTI
        </h1>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-white/95 mb-4">
          Conectando segurança, performance e inovação em TI
        </h2>
        <p className="text-lg sm:text-xl text-white/90 mb-12 max-w-3xl mx-auto">
          Tecnologia é meio. Resultado é fim. E a NexTI entrega os dois.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            onClick={() => scrollToSection('servicos')}
            size="lg"
            className="bg-white text-[#4A2B7F] hover:bg-gray-100 border-2 border-white text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 font-semibold transition-all duration-300 hover:scale-105 shadow-xl"
          >
            Conheça nossos serviços
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          <Button
            onClick={() => navigate('/login')}
            size="lg"
            variant="outline"
            className="bg-transparent text-white border-2 border-white hover:bg-white hover:text-[#4A2B7F] text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 font-semibold transition-all duration-300 hover:scale-105 shadow-xl"
          >
            Abrir chamado
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <MousePointerClick className="w-8 h-8 text-white/70 animate-pulse-slow" />
      </div>
    </section>
  );
};

export default Hero;